"use client";

import { Container } from "@/components/ui/Container";
import { Reveal } from "@/components/ui/Reveal";
import { SectionLabel } from "@/components/ui/SectionLabel";
import { SplitHeading } from "@/components/ui/SplitHeading";
import { SECTION_TITLE_CLASS } from "@/lib/typography";
import { TechStackGraph } from "@/components/sections/TechStackGraph";
import type { TechStackGroup } from "@/lib/content/types";

type TechStackProps = {
  techStack: TechStackGroup[];
  label?: string;
  title?: string;
  description?: string;
  hint?: string;
};

export function TechStack({
  techStack,
  label,
  title,
  description,
  hint,
}: TechStackProps) {
  if (!techStack.length || !title) return null;

  return (
    <section id="technology" className="py-20 md:py-28 lg:py-32">
      <Container>
        <Reveal>
          <header className="mx-auto max-w-3xl text-center">
            {label ? (
              <div className="mb-5 flex justify-center">
                <SectionLabel>{label}</SectionLabel>
              </div>
            ) : null}
            <SplitHeading className={SECTION_TITLE_CLASS}>
              {title}
            </SplitHeading>
            {description ? (
              <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-muted md:text-lg">
                {description}
              </p>
            ) : null}
          </header>
        </Reveal>
      </Container>

      <Reveal delay={0.08}>
        <div className="mt-10 w-full md:mt-12">
          <TechStackGraph groups={techStack} hint={hint} />
        </div>
      </Reveal>
    </section>
  );
}
